import { render, staticRenderFns } from "./group-add.vue?vue&type=template&id=1bf90046&scoped=true"
import script from "./group-add.vue?vue&type=script&lang=js"
export * from "./group-add.vue?vue&type=script&lang=js"
import style0 from "./group-add.vue?vue&type=style&index=0&id=1bf90046&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf90046",
  null
  
)

export default component.exports